import {BsSearch,BsGearFill,BsBanFill,BsCheckSquareFill } from 'react-icons/bs'
import {useDashData} from '../Contexts/DashboardDataContext';
import {useState} from 'react'

const DashboardResidences = () => {

    const {residencesData, updateResidence} = useDashData()
    const [searchQuery,setSearchQuery] = useState("")
    const [editId, setEditId] = useState(null);
    const [editFields, setEditFields] = useState({});
  
    const handleEditClick = (residence) => {
      setEditId(residence.id);
      setEditFields({
        type: residence.type || '',
        status: residence.status || '',
        note: residence.note || '',
      });
    };

    const handleFieldChange = (field, value) => {
        setEditFields(prev => ({ ...prev, [field]: value }));
    };
    
    const handleSave = async (id) => {
        try {
          await updateResidence(id, editFields);
          setEditId(null);
          alert('Residence updated!');
        } catch (err) {
          console.error('Failed to update residence:', err);
          alert('Error updating residence.');
        }
      };

    const handleCancel = () => {
        setEditId(null);
        setEditFields({});
    };

    // Filter residencesData based on search query
    const filteredResidences = residencesData.filter(home => {
        const query = searchQuery.toLowerCase();
    
        // Concatenate name and street to match how it's displayed in the table
        const fullAddress = `${home.name || ''} ${home.street || ''}`.toLowerCase();
        
        return (
            fullAddress.includes(query) ||
            (home.type && home.type.toLowerCase().includes(query)) ||
            (home.status && home.status.toLowerCase().includes(query)) ||
            (home.note && home.note.toLowerCase().includes(query))
        );
    });

    return(
    <div className="dashboard-table-page">
        <section className="dash-card dashboard-table-card">
        <div className="table-toolbar">
                <div className="search-box">
                    <BsSearch style={{fontSize: "1.2rem"}}/>
                    <input type="text" value={searchQuery} onChange={(e)=>setSearchQuery(e.target.value)} placeholder="Search residences"></input>
                </div>
                {/* <div style={{width: 100}}></div>
                    <div className="green-button" style={{borderRadius: 4, padding: 8, display:"flex",flexDirection:"row"}}>
                        <BsPlusCircle style={{fontSize:"1.2rem"}}/>
                        <div style={{width: 4}} />
                        <div style={{fontSize:"1rem"}}>create resident</div>
                    </div> */}
            </div>


    {!searchQuery ? (
        <table className="styled-table">
            <thead>
            <tr>
                <th width="5%">#</th>
                <th width="20%">Street</th>
                <th width="20%">Type</th>
                <th>Status</th>
                <th>Note</th>
                <th style={{width:"5rem"}}></th>
            </tr>
            </thead>
            <tbody>
                {residencesData.length > 0 ? (
                    residencesData.map((res) => (
                        <tr key={res.id}>
                        <td>{res.number || 'N/A'}</td>
                        <td>{(res.name + ' ' + res.street) || 'N/A'}</td>
                        {editId === res.id ? (
                          <>
                            <td><input type="text" value={editFields.type} onChange={e => handleFieldChange('type', e.target.value)} /></td>
                            <td><input type="text" value={editFields.status} onChange={e => handleFieldChange('status', e.target.value)} /></td>
                            <td><input type="text" value={editFields.note} onChange={e => handleFieldChange('note', e.target.value)} /></td>
                            <td>
                              <div style={{display:"flex", flexDirection:"row", justifyContent: "space-evenly"}}>
                                <div className="clickable" onClick={() => handleSave(res.id)}>
                                    <BsCheckSquareFill color="green" />
                                </div>
                                <div className="clickable" onClick={()=> handleCancel(res.id)}>
                                    <BsBanFill color="red" />
                                </div>
                              </div>

                            </td>
                          </>
                        ) : (
                          <>
                            <td>{res.type || 'N/A'}</td>
                            <td>{res.status || 'N/A'}</td>
                            <td>{res.note || 'N/A'}</td>
                            <td>
                              <div className="clickable" onClick={() => handleEditClick(res)}>
                                <BsGearFill color="blue" />
                              </div>
                            </td>
                          </>
                        )}
                      </tr>
                    ))
                ) : (
                    <tr>
                    <td colSpan="5" style={{ textAlign: "center", padding: "10px" }}>
                        No residences found
                    </td>
                    </tr>
                )}
                </tbody>
        </table>
    ) : (
        <table className="styled-table">
            <thead>
            <tr>
                <th>#</th>
                <th>Street</th>
                <th>Type</th>
                <th>Status</th>
                <th>Note</th>
                <th style={{width:"5rem"}}></th>
            </tr>
            </thead>
            <tbody>
                {filteredResidences.length > 0 ? (
                    filteredResidences.map((res) => (
                        <tr key={res.id}>
                        <td>{res.number || 'N/A'}</td>
                        <td>{(res.name + ' ' + res.street) || 'N/A'}</td>
                        {editId === res.id ? (
                          <>
                            <td><input type="text" value={editFields.type} onChange={e => handleFieldChange('type', e.target.value)} /></td>
                            <td><input type="text" value={editFields.status} onChange={e => handleFieldChange('status', e.target.value)} /></td>
                            <td><input type="text" value={editFields.note} onChange={e => handleFieldChange('note', e.target.value)} /></td>
                            <td>
                              <div style={{display:"flex", flexDirection:"row", justifyContent: "space-evenly"}}>
                                <div className="clickable" onClick={() => handleSave(res.id)}>
                                    <BsCheckSquareFill color="green" />
                                </div>
                                <div className="clickable" onClick={()=> handleCancel(res.id)}>
                                    <BsBanFill color="red" />
                                </div>
                              </div>

                            </td>
                          </>
                        ) : (
                          <>
                            <td>{res.type || 'N/A'}</td>
                            <td>{res.status || 'N/A'}</td>
                            <td>{res.note || 'N/A'}</td>
                            <td>
                              <div className="clickable" onClick={() => handleEditClick(res)}>
                                <BsGearFill color="blue" />
                              </div>
                            </td>
                          </>
                        )}
                      </tr>
                    ))
                ) : (
                    <tr>
                    <td colSpan="5" style={{ textAlign: "center", padding: "10px" }}>
                        No matching residences found
                    </td>
                    </tr>
                )}
                </tbody>
        </table>
    )}
    
    </section>
  </div>
    )
}

export default DashboardResidences
